import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'
import type { VerificationVolumePoint } from '@/src/types/admin/analytics'

interface VerificationAreaChartProps {
  data: VerificationVolumePoint[]
  height?: number
  showLegend?: boolean
}

function formatMonth(month: string): string {
  const [year, m] = month.split('-')
  const date = new Date(parseInt(year), parseInt(m) - 1, 1)
  return date.toLocaleDateString('th-TH', { month: 'short', year: '2-digit' })
}

export function VerificationAreaChart({
  data,
  height = 300,
  showLegend = true,
}: VerificationAreaChartProps) {
  const chartData = data.map((d) => ({
    month: formatMonth(d.month),
    สำเร็จ: d.successful,
    ล้มเหลว: d.failed,
  }))

  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={chartData} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
        <defs>
          <linearGradient id="colorSuccess" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorFailed" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ef4444" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 12 }}
          tickLine={false}
          axisLine={false}
        />
        <YAxis tick={{ fontSize: 12 }} tickLine={false} axisLine={false} width={40} />
        <Tooltip />
        {showLegend && <Legend />}
        <Area
          type="monotone"
          dataKey="สำเร็จ"
          stroke="#10b981"
          strokeWidth={2}
          fill="url(#colorSuccess)"
        />
        <Area
          type="monotone"
          dataKey="ล้มเหลว"
          stroke="#ef4444"
          strokeWidth={2}
          fill="url(#colorFailed)"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
